import fm from 'format-message';
import PropTypes from 'prop-types';
import useSiteSelectorQuery from 'queries/useSiteSelectorQuery';
import Seo from '@activebrands/core-web/components/seo-meta/structured-data/Seo';
import { styled, useStyletron } from '@activebrands/core-web/libs/styletron';
import DahlieFooterIcon from 'components/icons/DahlieFooterIcon';
import LogotypeIcon from 'components/icons/LogotypeIcon';

const Wrapper = styled('div', {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    gap: '12px',
    width: '100%',
    height: '100vh',
    zIndex: 1,
    transition: 'transform var(--transition-fast)',
    overflowY: 'scroll',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    color: 'var(--color-text-inverted)',
});

const SiteSelectorLayout = ({ children, location }) => {
    const [css] = useStyletron();
    const { seo = {} } = useSiteSelectorQuery();
    const seoData = { content: { seo } };
    const year = new Date().getFullYear();

    return (
        <>
            <Seo data={seoData} location={location} />
            <Wrapper>
                <header
                    className={css({
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'center',
                        padding: '24px',
                    })}
                >
                    <LogotypeIcon color="var(--color-top-logo-site-selector)" width="48px" />
                </header>
                {children}
                <footer
                    className={css({
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        backgroundColor: 'var(--color-bg-footer-primary)',
                        color: 'var(--color-text)',
                        padding: '16px',
                        alignItems: 'center',
                    })}
                >
                    <LogotypeIcon color="var(--fill-logo-footer)" width="40px" />
                    {fm('© { year } Dahlie', {
                        year,
                    })}
                </footer>
            </Wrapper>
        </>
    );
};

SiteSelectorLayout.propTypes = {
    children: PropTypes.node.isRequired,
    location: PropTypes.object,
};

export default SiteSelectorLayout;
